import React, { useState, useEffect } from 'react';
import desktopImage from '../assets/2.jpg';

import mobileImage from '../assets/Sushi.png';
import './AppDevelopment.css';

const AppDevelopment = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <section className="app-dev-fullscreen">
      {!isMobile && (
        <img
          src={require('../assets/1.jpg')}
          alt="App Development 1"
          className="fullscreen-image"
        />
      )}
      <img
        src={isMobile ? mobileImage : desktopImage}
        alt="App Development"
        className="fullscreen-image"
      />
    </section>
  );
};

export default AppDevelopment;
